import {
    START_LOADING,
    CREATE_VOUCHERS,
    FETCH_VOUCHERS,
    USE_VOUCHERS,
    DELETE_VOUCHERS,
    ERROR_VOUCHERS,
    END_LOADING,
  } from "../actions/constants";
  
  const initialState = {
    isLoading: false,
    vouchers: [],
    vouchersCompany: null,
    error: null,
  };
  
  const vouchers = (state = initialState, action) => {
    switch (action.type) {
      case START_LOADING:
        return { ...state, isLoading: true, error: null };
      case END_LOADING:
        return { ...state, isLoading: false };
        case CREATE_VOUCHERS:
          return {
            ...state,
            vouchers: [...state.vouchers, action.payload.data],
            error: null,
          };
          case FETCH_VOUCHERS:
            return { ...state, vouchersCompany: action.payload.data };

      case USE_VOUCHERS:
        return {
          ...state,
          vouchers: state.vouchers.map((vouchers) =>
            vouchers._id === action.payload._id ? action.payload : vouchers
          ),
          error: null,
        };
      case DELETE_VOUCHERS:
        return {
          ...state,
          vouchers: state.vouchers.filter(
            (vouchers) => vouchers._id !== action.payload
          ),
          error: null,
        };
        case ERROR_VOUCHERS:
            return {
                ...state,
                error: action.payload,
            };
      default:
        return state;
    }
  };
  
  export default vouchers;
  